import type {
  TopPvDataSource,
  TopPvProductsParams,
} from '~/api/data-source/top-pv';
import { topPvDataSource } from '~/api/data-source/top-pv';
import type { TopPvCategories, TopPvProducts } from '~/api/model';
import {
  parseModel,
  topPvCategoriesSchema,
  topPvProductsSchema,
} from '~/api/model';

export interface TopPvRepository {
  getTopPvProducts(params: TopPvProductsParams): Promise<TopPvProducts>;
  getTopPvCategories(hour: number): Promise<TopPvCategories>;
}

export class TopPvRepositoryImpl implements TopPvRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly dataSource: TopPvDataSource = topPvDataSource) {}

  async getTopPvProducts(params: TopPvProductsParams) {
    const response = await this.dataSource.getTopPvProducts(params);
    return parseModel(topPvProductsSchema, response, 'TopPvProducts');
  }

  async getTopPvCategories(hour: number) {
    const response = await this.dataSource.getTopPvCategories(hour);
    return parseModel(topPvCategoriesSchema, response, 'TopPvCategories');
  }
}

export const topPvRepository = new TopPvRepositoryImpl();
